import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import LayoutHeader from "@/layouts/default/Header/LayoutHeader.vue";
import LayoutFooter from "@/layouts/default/Footer/LayoutFooter.vue";
import LayoutBody from "@/layouts/default/Body/LayoutBody.vue";
import LayoutTransition from "@/layouts/default/Transition/LayoutTransition.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutDefault',
  props: ["is"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LayoutHeader),
    _createVNode(LayoutBody, null, {
      default: _withCtx(() => [
        _createVNode(LayoutTransition, null, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.is)))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(LayoutFooter)
  ], 64))
}
}

})